// setReplyMessageStatus.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
/**
 * Set reply message status
 * @kind action
 * @param {string} {messageId} - action param.
 * @param {replyIsSending} {bool} - action param.
 * @return {Promise} Action promise.
 */
const setReplyMessageStatus =
  ({ messageId, replyIsSending }) =>
  async dispatch => {
    const replySelectPath = ['message', messageId];
    return dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: replySelectPath,
        data: { replyIsSending },
      },
    });
  };

export default setReplyMessageStatus;
